<template>
  <div class="single-notification">
    <app-card
      :show-footer="false"
      :grey-header="!isNewNotification"
      :blue-header="isNewNotification"
    >
      <template #header-left>
        <div class="d-flex align-items-center">
          <div class="new-notification-indicator" v-if="isNewNotification"></div>
          <span v-if="isNewNotification" class="px-1"></span>
          <div class="font-weight-bold" v-if="notification.author">{{ notification.author }}</div>
          <span v-if="notification.author" class="px-1"></span>
          <div>{{ notification.date }}</div>
        </div>
      </template>
      <template #header-right>
        <template>
          <div>
            <component :is="($router ? 'router-link': 'a')"
                       :href="'/develop/notifications?type=' + notification.linkType"
                       :to="'/develop/notifications?type=' + notification.linkType">
              <span @click="$emit('close')">{{ notification.type }}</span>
            </component>
          </div>
        </template>
      </template>
      <template #text>
        <div class="notification-content">
          <school-notification :notification-data="notification.notificationData"
                               v-if="notification.type === 'School'"></school-notification>
          <review-notification :notification-data="notification.notificationData"
                               v-else-if="notification.notificationType === 'LessonReview'"></review-notification>
          <reviewed-notification :notification-data="notification.notificationData"
                                 v-else-if="notification.notificationType === 'LessonReviewed'"></reviewed-notification>
          <lesson-notification :notification-data="notification.notificationData"
                               v-else-if="notification.type === 'Lessons'"></lesson-notification>
          <discussion-notification
            :notification-data="notification.notificationData"
            :notification-type="notification.notificationType"
            :item-type="notification.itemType"
            :item-type-string="notification.itemTypeString"
            :is-new-notification="isNewNotification"
            v-else-if="notification.notificationType === 'Comment' ||
             notification.notificationType === 'PrivateComment' ||
              notification.notificationType === 'Note'"></discussion-notification>
          <share-notification :item-type="notification.itemType"
                              :item-type-string="notification.itemTypeString"
                              :notification-data="notification.notificationData"
                              v-else-if="notification.notificationType === 'Share'"></share-notification>
          <curriculum-view-notification :itemTypeString="notification.itemTypeString" :itemType="notification.itemType"
                                        :notification-data="notification.notificationData"
                                        v-else-if="notification.linkType === 'CurriculumViews'"></curriculum-view-notification>
          <course-assignment-notification :notification-data="notification.notificationData"
            v-else-if="notification.notificationType === 'courseAssignment'"></course-assignment-notification>
          <curriculum-update-notification
            :itemType="notification.itemType" :notification-data="notification.notificationData"
            v-else-if="notification.linkType === 'CurriculumUpdates'"></curriculum-update-notification>
          <report-update-notification :notification-data="notification.notificationData"
                                      v-else></report-update-notification>
        </div>
      </template>
      <template #labels>
        <div class="labels-block-wrapper">
          <attachment-label
            v-for="attachment in notification.attachments"
            :editable="false"
            :deletable="false"
            :key="attachment.id"
            :attachment="attachment"
            class="mx-1"
          />
        </div>
      </template>
    </app-card>
  </div>
</template>

<script>
import AppCard from '@/components/htmlHelpers/AppCard'
import CourseAssignmentNotification from '@/components/notificationsNew/notificationsByType/courseAssignmentNotification'
import SchoolNotification from '@/components/notificationsNew/notificationsByType/schoolNotification'
import LessonNotification from '@/components/notificationsNew/notificationsByType/lessonNotification'
import DiscussionNotification from '@/components/notificationsNew/notificationsByType/discussionNotification'
import ShareNotification from '@/components/notificationsNew/notificationsByType/shareNotification'
import CurriculumViewNotification from '@/components/notificationsNew/notificationsByType/curriculumViewNotification'
import CurriculumUpdateNotification from '@/components/notificationsNew/notificationsByType/curriculumUpdateNotification'
import ReportUpdateNotification from '@/components/notificationsNew/notificationsByType/reportUpdateNotification'
import BaseComponent from '@/components/commentsNew/BaseComponent'
import AttachmentLabel from '@/components/attachmentsNew/AttachmentLabel'
import ReviewNotification from '@/components/notificationsNew/notificationsByType/ReviewNotification'
import ReviewedNotification from '@/components/notificationsNew/notificationsByType/ReviewedNotification'

export default {
  name: 'SingleNotification',
  extends: BaseComponent,
  components: {
    ReviewedNotification,
    AttachmentLabel,
    ReportUpdateNotification,
    CurriculumUpdateNotification,
    CurriculumViewNotification,
    ShareNotification,
    DiscussionNotification,
    LessonNotification,
    CourseAssignmentNotification,
    SchoolNotification,
    AppCard,
    ReviewNotification
  },
  props: {
    notification: {
      type: Object,
      required: true
    }
  },
  computed: {
    isNewNotification () {
      return !!this.notification.new
    }
  }
}
</script>

<style scoped lang="scss">
@import "src/assets/scss/variables";

.single-notification {
  color: $text-color-gray;

  .notification-content {
    font-size: 16px;
    text-align: left;
  }

  .labels-block-wrapper {
    margin: 0 -4px;
  }
}

.new-notification-indicator {
  background-color: $primary;
  width: 8px;
  height: 8px;
  border-radius: 50%;
}
</style>
